<template>
<div class="main my">
  <!-- 定制课表 -->
  <div class="bcw">
    <div class="model-box fs2 bcw clear">
      <c-select
          text="全部课程"
          :actions="orderTypes"
          @select="selectType"
          class="type-select right green"
        ></c-select>
    </div>
    <form class="clear" @submit.prevent="checkForm" v-cloak>
      <!-- 限制选中个数  :max="this.$route.query.num*1"  -->
      <van-checkbox-group v-model="result">
        <van-cell-group>
          <van-cell
            v-for="(item,index) in courseListAll"
            clickable
            :key="item.id"
            :title="item.title"
            @click="toggle(index)">
            <van-checkbox checked-color="#4b0" :name="item.id" ref="checkboxes" />
          </van-cell>
        </van-cell-group>
        <the-btnbar text="定制课表"></the-btnbar>
      </van-checkbox-group>
    </form>
  </div>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import AvatarBox from '@/components/AvatarBox';
import TheBtnbar from './components/TheBtnBar';
import CSelect from "@/components/Select";
import {
  Cell, CellGroup,Checkbox, CheckboxGroup,SwitchCell,Toast
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(SwitchCell).use(Toast);

export default {
  components: {
    AvatarBox,TheBtnbar,CSelect
  },
  data() {
    return {
      result: [],  //select选中状态 存对应的id值[5,6]

      // courseList:{}, //课程列表
      courseListAll:{}, //课程列表
      orderTypes: [
        {
          name: "全部课程",
          type: null
        }
      ],
      currentType: {},//当前筛选类型
      postForm:{
        id:this.$route.query.id,
        courseList:[]
      },
      classType:this.$route.query&&this.$route.query.type //私教or月课
    }
  },
  created(){
    // 全部课表
    this.$http.post('grading_course/getList').then(res => {
      if (!res.data.code) {
        let arr = res.data.value.map(i=>{
          return {
            id:i.id,
            title:i.title
          }
        })
        this.courseListAll = arr
      } else {
        //Toast.fail(res.data.message);
      }
    })

    // 制定课表
    let url = ''
    if(this.classType == 'month'){
      // 月课
      url = 'product_manage/getInfo'
    }else{
      // 私教课
      url = 'club_pt_course_manage/getInfo'
    }
    this.$http.post(url,{
      id:this.$route.query.id
    }).then(res => {
      if (!res.data.code) {
        // 拼接数据为id数组，显示选中状态
        if(res.data.value.courseList){
          let arr = res.data.value.courseList.map(i=>{
            return i.id
          })
          this.result = arr
        }
      } else {
        //Toast.fail(res.data.message);
      }
    })

    // console.log(this.classType)
  },
  methods: {
    selectType(item) {
      //select筛选
      this.currentType = item;
    },
    toggle(index) {
      // console.log(index)
      // console.log(this.result)  //存id [5,6]
      this.$refs.checkboxes[index].toggle();
    },
    checkForm: function(){
      // 拼接成新数组：根据id值，取课表的title，
      let newaa = []
      // 注意不要用return
      this.courseListAll.map(i=>{
        if(this.result.indexOf(i.id) !== -1){
          newaa.push({
            id:i.id,
            title:i.title
          })
        }
      })
      // console.log(newaa)

      let _this = this
      let temp = JSON.parse(JSON.stringify(_this.postForm))
      temp.courseList = JSON.stringify(newaa)
      // console.log(temp)

      // 提交表单
      let url = ''
      if(this.classType == 'month'){
        // 月课
        url = 'product_manage/edit'
      }else{
        // 私教课
        url = 'club_pt_course_manage/edit'
      }
      _this.$http.post(url,temp).then(function(res){
          if(res.data.code == 0){
            Toast.success({                
              message:'定制成功！',
              duration:1000 
            })
            setTimeout(function(){
              _this.$router.go(-1)
            }, 1000) 
          }else{
            Toast(res.data.message)
          }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.my-model{
  padding: .1rem 0; 
}
.cell-item{
  &__img{
    float: left;
    width: .5rem;
    margin: .05rem 0 0 .1rem;
  }
  &__cell{
    float: left;
    width: calc(100% - 0.6rem);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manage/PrivateCourseTimetable.vue